<template>
    <div>
        <div ref="lottieEl" class="lottie"></div>
    </div>
</template>

<script>
    export default {
        name: 'animation',
        props: {
            animation: {
                type: Object,
                default: {}
            },
            autoplay: {
                type: Boolean,
                default: true
            },
            step: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                el: undefined
            }
        },
        watch: {
            '$root.mode'() {
                if (this.$refs.lottieEl) {
                    this.$nextTick(() => {
                        this.$root.lottieIESvgResize(this.$refs.lottieEl);
                    })
                }
            }
        },
        mounted() {
            let params = {
                container: this.$refs.lottieEl,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: this.animation
            };

            this.el = lottie.loadAnimation(params);
            lottie.setSpeed(.5);

            this.$nextTick(() => {
                this.$root.lottieIESvgResize(this.$refs.lottieEl);

                $('[id*="step"]').on('click', (event) => {
                    event.preventDefault();

                    let arr = [],
                        f = 0;

                    let step = parseInt(event.currentTarget.id.replace('step', ''));

                    this.el.pause();
                    this.$emit('update:step', step);

                    switch(step) {
                        case 1:
                            f = 20;
                            // arr = [1, 150];
                            break;

                        case 2:
                            f = 169;
                            // arr = [150, 300];
                            break;

                        case 3:
                            f = 320;
                            // arr = [300, 450];
                            break;

                        case 4:
                            f = 472;
                            // arr = [450, 600];
                            break;
                    }

                    this.el.goToAndStop(f, true);
                    // this.el.playSegments(arr, true);

                    // stop parent interval
                    this.$parent.$emit('interval:clear', true);
                });
            });
        }
    }
</script>

<style lang="scss">
    .lottie {
        [id*="step"] {
            cursor: pointer;
        }
    }
</style>